module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "integrationTopArea px-5"
  }, [_c('div', {
    staticClass: "border-bottom-medium d-flex flex-row align-items-center py-4"
  }, [(_vm.logo) ? _c('div', {
    staticClass: "leftArea text-center"
  }, [_c('img', {
    staticStyle: {
      "max-width": "80%",
      "max-height": "75px"
    },
    attrs: {
      "src": _vm.logo,
      "alt": "Logo"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "rightArea flex-grow-1 w-100"
  }, [_c('div', {
    staticClass: "darkest"
  }, [_vm._v("\n                " + _vm._s(_vm.integration.descriptionModal || _vm.integration.descriptionSmall) + "\n            ")]), _vm._v(" "), _vm._t("default")], 2)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-1e7d2ec1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e7d2ec1"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/integrations/integratePopup/popupParts/topArea.vue
// module id = 2188
// module chunks = 0